import { useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import type { FC } from 'react';
import { DividedLine, DividedText, DividerWrapper } from './Divider.style';

interface DividerProps {
  children: React.ReactNode;
}
export const Divider: FC<DividerProps> = ({ children }) => {
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);

  return (
    <DividerWrapper isDesktop={isDesktopPMT}>
      <DividedLine>
        <DividedText>{children}</DividedText>
      </DividedLine>
    </DividerWrapper>
  );
};
